import { NUMBER_REGEX } from '@shared/constants/regexes';
import dayjs from 'dayjs';
import isNil from 'lodash/isNil';

export type Nil<T> = T | null | undefined;

const deserializer = <T>(value: Nil<string>): Nil<T> => {
	if (isNil(value)) return value;

	let newValue: any;

	if (NUMBER_REGEX.test(value) && isNaN(Number(value))) {
		newValue = Number(value);
	} else if (dayjs(value).isValid()) {
		newValue = dayjs(value).toDate();
	} else if (value === 'true') {
		newValue = true;
	} else if (value === 'false') {
		newValue = false;
	} else if (value === 'undefined') {
		newValue = undefined;
	} else if (value === 'null') {
		newValue = null;
	} else {
		try {
			newValue = JSON.parse(value);
		} catch {
			newValue = value;
		}
	}

	return newValue;
};

const serializer = (value: any): string => {
	switch (typeof value) {
		case 'string':
			return value;
		case 'number':
		case 'boolean':
		case 'bigint':
			return String(value);
		case 'object':
			return JSON.stringify(value);
		case 'undefined':
		case 'symbol':
		case 'function':
		default:
			return 'undefined';
	}
};

export const deserializeLocalStorageValue = <T>(key: string): Nil<T> => {
	const value = window.localStorage.getItem(key);
	return deserializer<T>(value);
};

export const serializeLocalStorageValue = (key: string, value: any): string => {
	window.localStorage.setItem(key, serializer(value));
	return window.localStorage.getItem(key) as string;
};
